export const DTA_TYPE = {
  DIRECT: 'b2c_direct',
  REFERRAL: 'b2c_referral',
} as const;